export enum DirectoryRecordActionType {
  archive,
  dearchive,
  edit,
}
